import React from 'react';

export default function CreateBusinessHeader({
    title = 'Создать бизнес',
    subtitle = 'Заполните данные и выберите локацию на карте',
    onBack,
    backClassName = '',
    right = null,
}) {
    return (
        <header className="shop-create-header">
            <div className="shop-create-headerRow">
                {typeof onBack === 'function' ? (
                    <button
                        type="button"
                        className={`shop-create-headerBack${backClassName ? ` ${backClassName}` : ''}`}
                        onClick={onBack}
                        aria-label="Назад"
                        title="Назад"
                    >
                        <svg
                            className="shop-create-headerBackIcon"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M15 6l-6 6 6 6"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                ) : null}

                <div className="shop-create-headerText">
                    <div className="shop-create-title">{title}</div>
                    <div className="shop-create-subtitle">{subtitle}</div>
                </div>
                {right}
            </div>
        </header>
    );
}

